import { CardHeader, CardPreview, Drawer } from "@verde/compose-ui";
import { type FetchClient, useFetchFieldInsight } from "@verde/entities";
import {
  BirthdayFarmer,
  SeuVerdeIcon,
  UserIcon,
  WhatsappIcon,
} from "@verde/icons";
import { useAuthContext } from "@verde/modules";
import { Skeleton } from "@verde/ui-core";
import { formatDate } from "@verde/utils";
import { useCallback } from "react";
import type { BirthdayDrawerProps } from "./types";

export default function BirthdayDrawer({
  onClose,
  open,
  insightFieldId,
}: BirthdayDrawerProps) {
  const { data: birthDays, isLoading } = useFetchFieldInsight(insightFieldId);

  const { user } = useAuthContext();

  const handlerBirthDayZap = useCallback(
    (client?: Partial<FetchClient>) => {
      const mensagem = `https://wa.me/${client?.phone_number?.replace(/[^a-zA-Z0-9]/g, "")}?text=%20**Olá%20${client?.name}!%20Parabéns%20pelo%20seu%20dia!**%20%0A%0ADesejamos%20a%20você%20um%20feliz%20aniversário%2C%20com%20muita%20saúde%2C%20prosperidade%20e%20conquistas!%20Que%20seu%20novo%20ciclo%20venha%20repleto%20de%20boas%20colheitas%20—%20no%20campo%20e%20na%20vida.%20%0A%0AConte%20sempre%20com%20a%20gente%20no%20que%20for%20preciso.%20Estamos%20juntos!%0A%0AUm%20grande%20abraço%2C%0A${user?.name}`;
      window.open(mensagem, "_blank");
    },
    [user?.name],
  );

  return (
    <Drawer
      open={open}
      onClose={onClose}
      header={{
        title: "Produtores aniversariantes",
        icon: <BirthdayFarmer className="h-6 w-6" />,
        description:
          "Confira aqui os produtes da sua carteira que fazem aniversário este mês!",
      }}
      footer={{ primary: { children: "Fechar", onClick: onClose } }}
    >
      <div className="grid gap-6">
        <div className="grid gap-3">
          {isLoading ? (
            <>
              <Skeleton height={30} />
              <Skeleton height={30} />
              <Skeleton height={30} />
            </>
          ) : (
            birthDays?.clients?.map((client) => {
              return (
                <CardPreview
                  size="sm"
                  key={`birthDay-card-${client?.id}`}
                  icon={<UserIcon />}
                  title={client?.name}
                  description={
                    client?.birth_date
                      ? `Aniversário ${formatDate(client?.birth_date)}`
                      : "-"
                  }
                  actions={{
                    primary: {
                      icon: <WhatsappIcon />,
                      disabled: !client.phone_number,
                      onClick: () => handlerBirthDayZap(client),
                    },
                  }}
                />
              );
            })
          )}
        </div>
      </div>
    </Drawer>
  );
}
